require('./bootstrap');
import 'htmx.org';
import './htmx.js';
import Sortable from 'sortablejs';

document.addEventListener('DOMContentLoaded', (event) => {
    new Sortable(document.getElementById('downloader-tbody'), {
        handle: '.sort-handler', // Specifica il p come handle per il drag-and-drop
        animation: 150,
        // onEnd: function (evt) {
        //     // Aggiungi qui il codice che vuoi eseguire quando l'ordinamento è completato
        //     console.log('Row moved from index', evt.oldIndex, 'to', evt.newIndex);
        // }
    });

    addRemoveRowListeners();

    document.getElementById('downloader-test-button').addEventListener('click', testResponseFromDownloader);
    document.getElementById('downloader-download-button').addEventListener('click', downloadFileFromUrl);

    document.getElementById('downloader').querySelector('select[name="fileFormat"]').addEventListener('change', (event) => {
        let fileFormat = event.currentTarget.value;
        if (fileFormat === 'sql') {
            document.getElementById('table-name-wrapper').classList.remove('hidden');
            document.getElementById('table-name-wrapper').classList.add('flex');
        } else {
            document.getElementById('table-name-wrapper').classList.add('hidden');
            document.getElementById('table-name-wrapper').classList.remove('flex');
        }
    });
});

document.addEventListener('htmx:afterSwap', (event) => {
    if (event.detail.target.id === 'downloader-tbody') {
        addRemoveRowListeners();
    }
});

function handleRemoveRow(event) {
    const button = event.currentTarget;
    const row = button.closest('tr.downloader-row');
    if (row) {
        row.remove();
    }
}

function addRemoveRowListeners() {
    const removeRowButtons = document.querySelectorAll('[data-scope="remove-row"]');
    removeRowButtons.forEach((button) => {
        button.removeEventListener('click', handleRemoveRow); // Rimuove eventuali vecchi listener per evitare duplicazioni
        button.addEventListener('click', handleRemoveRow);
    });
}

function testResponseFromDownloader() {
    let { rowsNumber, locale, params } = handleDownloaderElements();
    
    let url = `${window.location.origin}/api/v2/custom?_quantity=${rowsNumber}&_locale=${locale}`;
    params.forEach((param) => {
        url += `&${param.key}=${param.value}`;
    });

    window.open(url, '_blank');
}

async function downloadFileFromUrl() {
    let { rowsNumber, locale, params } = handleDownloaderElements();
    let fileFormat = document.querySelector('#downloader').querySelector('select[name="fileFormat"]').value || 'csv';
    
    let formData = new FormData();
    formData.append('_quantity', rowsNumber);
    formData.append('_locale', locale);
    formData.append('_fileFormat', fileFormat);
    if (fileFormat === 'sql') {
        let tableName = document.querySelector('#downloader').querySelector('input[name="tableName"]').value;
        formData.append('_tableName', tableName);        
    }
    params.forEach((param) => {
        formData.append(param.key, param.value);
    });

    try {
        // get csrf token from meta tag
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        const response = await fetch(`${window.location.origin}/fake-data-download`, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrfToken,
            },
            body: formData,
        });

        // Controlla se la risposta è andata a buon fine
        if (!response.ok) {
            throw new Error(`Errore: ${response.status}`);
        }

        // Converti la risposta in un Blob (necessario per gestire file binari)
        const blob = await response.blob();

        // Estrarre il nome del file dall'intestazione Content-Disposition
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'fake-data';
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch.length > 1) {
                filename = filenameMatch[1].replace(/['"]/g, '');
            }
        }

        // Crea un URL temporaneo per il download
        const downloadUrl = window.URL.createObjectURL(blob);
        
        // Crea un elemento link temporaneo
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;

        // Simula un clic sul link per avviare il download
        document.body.appendChild(link);
        link.click();

        // Rimuovi il link temporaneo
        link.remove();

        // Libera l'URL creato
        window.URL.revokeObjectURL(downloadUrl);

    } catch (error) {
        console.error('Error downloading file:', error);
    }
}

function handleDownloaderElements() {
    const downloader = document.querySelector('#downloader');
    let downloaderParams = downloader.querySelectorAll('tr.downloader-row');
    let rowsNumber = downloader.querySelector('input[name="rows"]').value;
    let locale = downloader.querySelector('select[name="locale"]').value;

    let params = getParams(downloaderParams);

    return { rowsNumber, locale, params };
}

function getParams(downloaderParams) {
    let params = [];
    downloaderParams.forEach((param) => {
        let key = param.querySelector('input[name="fieldName"]').value;
        let value = param.querySelector('select[name="fieldType"]').value;
        if (key && value) {
            params.push({ key, value });
        }
    });

    return params;
}